/**
 * Created by intellicar-rinas on 4/1/18.
 */
import React, {Component} from 'react';
import './AppScreen.css';
import moment from 'moment';
import {dateFormat} from '../../../../constants/constants';

class AppScreen extends Component {

    state = {
        stats:{}
    };

    constructor(){
        super();

        this.updateView =()=> {
            // console.log(this.props.vehicle());
            this.setState({stats:this.props.vehicle().stats}, this.forceUpdate);
            // console.log(this.props.vehicle);
            setTimeout(()=>{
                this.setState({stats:this.props.vehicle().stats}, this.forceUpdate);
                // console.log(this.props.vehicle());
            }, 100);
        };

        this.getOffset =(val, lim, dash=138)=> {
            return dash - (val/lim * dash);
        }

        this.getTime =()=> {
            return moment(this.state.stats.time).format('DD-MMM-YYYY HH:mm:ss');
        }

        this.getRamOffset =()=> {
            return 213 - (this.state.stats.ramUsed / (this.state.stats.ramUsed + this.state.stats.ramFree) * 213);
        }

    }

    getName =()=> {
        let userid = this.props.vehicle().name;
        return (userid||'').charAt(0).toUpperCase() + (userid||'').slice(1)
    }

    render() {
        return (
            <div className="AppScreen">
                <div className="as-header">
                    <div className="ash-name">{this.getName()}</div>
                    <div className="ash-desc1">{this.props.vehicle().stats.model}</div>
                    <div className="ash-desc2">Android Version {this.props.vehicle().stats.androidVersion}</div>
                    {/* <div className="ash-desc3">Phone Number</div> */}
                    {/* <div className="ash-button">TRACK</div> */}
                    <div className="ash-desc4">{this.getTime()}</div>
                </div>
                <div className="as-controls">
                    <div className={"asc-item "+(this.state.stats.signalStatus ? '-active':null)}>
                        <div className="asci-icon"><svg><circle></circle></svg>
                            <i className="fa fa-signal"></i>
                        </div>
                        <div className="asci-name">Network</div>
                    </div>
                    <div className={"asc-item "+(this.state.stats.locationStatus ? '-active':null)}>
                        <div className="asci-icon"><svg><circle></circle></svg>
                            <i className="fa fa-map-marker"></i>
                        </div>
                        <div className="asci-name"></div>
                    </div>
                    <div className="asc-item -active">
                        <div className="asci-icon"><svg><circle style={{strokeDashoffset:this.getOffset(this.state.stats.temperature, 70)}}></circle></svg>
                            <i className="fa fa-thermometer-1"></i>
                        </div>
                        <div className="asci-name">{this.state.stats.temperature}℃</div>
                    </div>
                    <div className={"asc-item "+(this.state.stats.wifiStatus ? '-active':null)}>
                        <div className="asci-icon"><svg><circle></circle></svg>
                            <i className="fa fa-wifi"></i>
                        </div>
                        <div className="asci-name">{this.state.stats.ssid!=='none'?this.state.stats.ssid:''}</div>
                    </div>
                    <div className={"asc-item "+(this.state.stats.bluetoothStatus ? '-active':null)}>
                        <div className="asci-icon"><svg><circle></circle></svg>
                            <i className="fa fa-bluetooth-b"></i>
                        </div>
                        <div className="asci-name"></div>
                    </div>
                    <div className="asc-item -active">
                        <div className="asci-icon"><svg><circle style={{strokeDashoffset:this.getOffset(this.state.stats.batteryRemaining, 100)}}></circle></svg>
                            <i className="fa fa-battery-2"></i>
                        </div>
                        <div className="asci-name">{this.state.stats.batteryRemaining}%</div>
                    </div>
                </div>
                <div className="as-content">
                    <div className="asc-block ascb-1">
                        <div className="ascb1-desc1">RAM & CPU USAGE</div>
                        <div className="ascb1-desc2">{parseFloat((this.state.stats.ramFree + this.state.stats.ramUsed) / 1024).toFixed(2)}<span>GB</span></div>
                        <div className="ascb1-desc3">Total RAM</div>
                        <div className="ascb1-desc4">Ram Usage</div>
                        <div className="ascb1-desc5">CPU Usage</div>
                        <div className="ascb1-desc6">{this.state.stats.cpuUsage}%</div>
                        <div className="ascb1-desc7">{parseInt(this.state.stats.ramUsed / (this.state.stats.ramFree + this.state.stats.ramUsed) * 100)}%</div>
                        <div className="ascb1-circle1">
                            <svg><circle style={{strokeDashoffset:this.getRamOffset()}}></circle></svg>
                        </div>
                        <div className="ascb1-circle2">
                            <svg><circle style={{strokeDashoffset:this.getOffset(this.state.stats.cpuUsage, 100, 213)}}></circle></svg>
                        </div>
                    </div>
                    {
                        this.state.stats.chargingStatus !== 0 ? (
                            <div className="asc-block -small">
                                {this.state.stats.chargingStatus === 1 ? 'USB Charging' : 'Power Charging'}
                            </div>
                        ) : null
                    }
                    <div className="asc-block -small">
                        <span className='ascb-metricName'>Speed </span>
                        <span className='ascb-value'>{this.state.stats.speed}</span>
                        <span className='ascb-unit'>Kmph</span>
                    </div>
                    <div className="asc-block -small -freeHeight -freeText">
                        {this.state.stats.address || 'Address info not Available'}
                    </div>
                </div> 
            </div>
        )
    }

}

export default AppScreen;